module.exports = __webpack_public_path__ + "img/Falkberget_Ung_i_Valdres.04937e46.jpg";